import React, { useEffect, useState } from "react";
import { getMieterArray, sendAdminEmail } from "../api";
import Animation from "../components/Animation";

function AdminEmailPage() {
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [receivers, setReceivers] = useState([]);
  const [mieterList, setMieterList] = useState([]);
  const [loading, isLoading] = useState(false);

  useEffect(() => {
    const fetchMieters = async () => {
      const token = localStorage.getItem("token");
      try {
        const result = await getMieterArray(token);
        setMieterList(result);
      } catch (error) {
        console.error("Fehler beim Laden der Mieter:", error);
      }
    };
    fetchMieters();
  }, []);

  const handleAddReceiver = (mieter) => {
    if (!receivers.find((r) => r.id === mieter.id)) {
      setReceivers((prev) => [...prev, mieter]);
    }
  };

  const handleRemoveReceiver = (id) => {
    setReceivers((prev) => prev.filter((r) => r.id !== id));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
    isLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    if (!subject || !message || receivers.length === 0) {
      alert("Bitte alle Felder ausfüllen.");
      return;
    }

    const payload = {
      subject,
      message,
      mieter_ids: receivers.map((r) => r.id),
    };

    try {
      await sendAdminEmail(payload, token);
      alert("E-Mail erfolgreich gesendet!");
      setSubject("");
      setMessage("");
      setReceivers([]);
    } catch (error) {
      console.error("Fehler beim Senden:", error);
      alert("Senden fehlgeschlagen.");
    }finally{isLoading(false)}
  };

  return (
    <div style={{ padding: "2rem", maxWidth: "800px", margin: "auto" }}>
      <h1 className="text-xl font-bold mb-4">📧 E-Mail an Mieter senden</h1>

      <form onSubmit={handleSubmit} className="space-y-6">
  <div>
    <label>Betreff:</label>
    <input
      type="text"
      value={subject}
      onChange={(e) => setSubject(e.target.value)}
      required
      className="w-full border rounded p-2"
    />
  </div>

  <div>
    <label>Nachricht:</label>
    <textarea
      value={message}
      onChange={(e) => setMessage(e.target.value)}
      rows="10"
      className="border rounded p-3 text-base"
      required
      style={{
        width: "100%",
        minHeight: "300px",
        fontSize: "16px",
        fontFamily: "Arial, sans-serif",
        resize: "vertical",
      }}
    />
  </div>

  <div>
    <label>Empfänger:</label>
    <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", margin: "1rem 0" }}>
  {receivers.map((mieter) => (
    <div
      key={mieter.id}
      style={{
        position: "relative",
        backgroundColor: "#fde68a",
        border: "1px solid #fbbf24",
        padding: "8px 12px 8px 16px",
        borderRadius: "10px",
        fontSize: "14px",
        color: "#333",
        fontWeight: "500",
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
      }}
    >
      <span>{mieter.name || mieter.user}</span>
      <button
        type="button"
        onClick={() => handleRemoveReceiver(mieter.id)}
        style={{
          fontSize: "20px",
          fontWeight: "bold",
          color: "#dc2626",
          background: "transparent",
          border: "none",
          cursor: "pointer",
          padding: 0,
          lineHeight: 1,
          alignSelf: "flex-start", // ⬅️ push it up slightly
          marginTop: "-2px",        // ⬅️ small vertical tweak
          boxShadow: "none",        // ⬅️ remove any shadow
        }}
        aria-label="Entfernen"
      >
        ×
      </button>
    </div>
  ))}
</div>


  </div>

  <div>
    <label>Aus Mieter-Liste auswählen:</label>
    <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginTop: "1rem" }}>
  {mieterList.map((mieter) => (
    <button
      type="button"
      key={mieter.id}
      onClick={() => handleAddReceiver(mieter)}
      style={{
        backgroundColor: "#fff7e6", // soft yellow background
        border: "1px solid #facc15", // golden border
        padding: "6px 12px",
        borderRadius: "8px",
        fontSize: "13px",
        color: "#333", // 👈 ensures text is visible
        fontWeight: "500",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        cursor: "pointer",
      }}
    >
      {mieter.name || mieter.user}
    </button>
  ))}
</div>

  </div>

  <button
    type="submit"
    className="bg-orange-600 text-white px-5 py-2 rounded hover:bg-orange-700 mt-4"
  >
    E-Mail senden
  </button>
</form>
 <Animation loading={loading}/>
    </div>
  );
}

export default AdminEmailPage;
